/* src/pages/AuthAction.jsx
 * Legacy Firebase /__/auth/action dispatcher — routes by mode query param
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import VerifyEmail from './VerifyEmail';
import ResetPassword from './ResetPassword';

export default function AuthAction() {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode');

  if (mode === 'resetPassword') {
    return <ResetPassword />;
  }

  return <VerifyEmail />;
}
